import { FACE_BY_ID } from "~/lib/faces";
import { useFaceSeo } from "~/lib/seo/useSeo";
import { PaginaDisciplina } from "~/ui/PaginaDisciplina";

export function Augment() {
  const face = FACE_BY_ID.augment;
  useFaceSeo(face);

  return (
    <PaginaDisciplina
      rotulo="Realidade aumentada"
      titulo="Conteúdo que aparece em cima do mundo real."
      intro="Realidade aumentada e virtual com Vuforia, AR Foundation e Unity XR, num caminho único que atende Android e iOS sem manter dois projetos separados."
      entrego={[
        {
          titulo: "Por marcador",
          corpo: "Vuforia, com imagem de referência. É o que funciona em embalagem, material impresso e educação.",
        },
        {
          titulo: "Sem marcador",
          corpo: "AR Foundation reconhecendo o ambiente, com um código só para ARCore e ARKit.",
        },
        {
          titulo: "Realidade virtual",
          corpo: "Unity XR com alvo Quest, locomoção confortável e interface que não embrulha o estômago.",
        },
        {
          titulo: "Ferramenta de autoria",
          corpo: "Extensão de editor para a equipe de conteúdo publicar cena nova sem depender de programador.",
        },
      ]}
      nota="Os trabalhos de realidade aumentada que entreguei estão sob acordo de confidencialidade ou ainda não lançaram, então não dá para listar aqui. Numa conversa eu mostro o que é possível mostrar e explico as decisões técnicas de cada um."
    />
  );
}
